export const PAYMENT_TYPES = {
  DEPOSIT:   { value: 1, label: 'Deposit' },
  WITHDRAW:  { value: 2, label: 'Withdraw' },
  PAY_ORDER: { value: 3, label: 'Pay Order' },
  DISCOUNT:  { value: 6, label: 'Discount' },
};

export const PAYMENT_TYPE_MAP = Object.fromEntries(
  Object.values(PAYMENT_TYPES).map(t => [t.value, t.label])
);

export const PAYMENT_TYPE_DEPOSIT   = PAYMENT_TYPES.DEPOSIT.value;
export const PAYMENT_TYPE_WITHDRAW  = PAYMENT_TYPES.WITHDRAW.value;
export const PAYMENT_TYPE_PAY_ORDER = PAYMENT_TYPES.PAY_ORDER.value;
export const PAYMENT_TYPE_DISCOUNT  = PAYMENT_TYPES.DISCOUNT.value;
